// Méga-menus (src/Chrome.php, templates/components/anima/mega-menus.twig). Un panneau par
// élément de menu de premier niveau portant la classe `anima-mega-<type>` : il s'ouvre au
// survol ou au focus de l'élément, à partir du point bureau (1 080 px, maquette « 30 sept »), et
// se ferme quand la souris quitte l'en-tête ou à la touche Échap. En dessous : menu-mobile-anima.js.

const DESKTOP = window.matchMedia('(min-width: 1080px)')
const CLOSE_DELAY = 120 // ms, le temps de glisser de l'élément au panneau

const init = () => {
  const header = document.getElementById('header')
  const panels = [...document.querySelectorAll('[data-anima-mega]')]
  if (!header || !panels.length) {
    return
  }

  let current = null
  let timer = null

  const close = () => {
    if (current) {
      current.panel.hidden = true
      current.item.classList.remove('is-mega-open')
      current.link.setAttribute('aria-expanded', 'false')
      current = null
    }
    header.classList.remove('has-mega-open')
  }

  const open = (entry) => {
    clearTimeout(timer)
    if (!DESKTOP.matches || current === entry) {
      return
    }
    close()
    entry.panel.hidden = false
    entry.item.classList.add('is-mega-open')
    entry.link.setAttribute('aria-expanded', 'true')
    header.classList.add('has-mega-open')
    current = entry
  }

  panels.forEach((panel) => {
    const item = document.querySelector(`#nav-main .menu-item-${panel.dataset.animaMega}`)
    const link = item && item.querySelector(':scope > .nav-link, :scope > a')
    if (!item || !link) {
      return
    }
    const entry = {
      panel,
      item,
      link
    }
    link.setAttribute('aria-haspopup', 'true')
    link.setAttribute('aria-expanded', 'false')
    link.setAttribute('aria-controls', panel.id)
    item.addEventListener('mouseenter', () => open(entry))
    link.addEventListener('focus', () => open(entry))
    panel.addEventListener('mouseenter', () => clearTimeout(timer))
  })

  // Les autres éléments de premier niveau referment le panneau ouvert.
  document.querySelectorAll('#nav-main .nav-item').forEach((item) => {
    if (![...item.classList].some((c) => c.startsWith('anima-mega-'))) {
      item.addEventListener('mouseenter', () => close())
    }
  })

  header.addEventListener('mouseleave', () => {
    timer = setTimeout(close, CLOSE_DELAY)
  })
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && current) {
      const {
        link
      } = current
      close()
      link.focus()
    }
  })
  document.addEventListener('focusin', (e) => {
    if (current && !header.contains(e.target)) {
      close()
    }
  })
  DESKTOP.addEventListener('change', close)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
